// extracted by mini-css-extract-plugin
export default {"nav":"App_nav__kJlKP","footer":"App_footer__hTLqU","body":"App_body__kRu0I"};